module.exports = __webpack_public_path__ + "static/media/lamina25act.bfaac032.png";